import ExpertPool from "../components/dashboard/marketing/ExpertPool";

export default function MarketingPoolPage() {
  return (
    <div className="w-full text-left">
      <ExpertPool />
    </div>
  );
}
